import { Award, Gear } from "react-bootstrap-icons";

export const GET_API_URLS = {
  STORE_URL: "/api/admin/canco/get_store/",
  STORE_TIMING_URL: "/api/admin/canco/store_timings/",
  ADD_NEW_LOCATION_URL: "/api/admin/canco/store/",
  SUB_ADMIN_URL: "/api/admin/accounts/users/",
  PROMOTIONS_URL: "/api/admin/promotions",
  WEB_PROMOTIONS: "/api/admin/webpromotions/webpromotions/",
  WEB_PROMOTIONS_CATEGORY: "/api/admin/webpromotions/category/",
  BLOG_URL: "/api/admin/cancoblog/",
  CITIES: "/api/admin/canco/city/",
  PROVINCE: "/api/admin/canco/province/",
  MODULE: "/api/admin/accounts/module/",
  BANNER: "/api/canco/banner/",
  BANNERS: "/api/canco/banners/",
  AMENITIES: "/api/admin/canco/amenities/",
  GAS_TYPE: "/api/admin/canco/gas_types/",
  COFFEE_USER_REWARDS: "/api/canco-coffee/admin/coffee-rewards/",
  COFFEE_STORE_REWARDS: "/api/admin/canco/coffee-store-rewards/",
  COFFEE_EVENTS: "/api/canco-coffee/admin/coffee-events/",
  CAROUSEL: "/api/admin/canco/carousel/",
  PROPANE_POPUP: "/api/admin/propane/popups/",
  PROPANE_PROMOTIONS: "/api/admin/propane/promotions/",
};

export const POST_API_URLS = {
  LOGIN_URL: "/api/admin/accounts/login/",
  ADD_NEW_LOCATION_URL: "/api/admin/canco/store/",
  GAS_LOCATION_URL: "/api/admin/gas-plus/locations/",
  ADD_SUB_ADMIN_URL: "/api/admin/accounts/register/",
  ADD_PROMO_URL: "/api/admin/promotions/",
  ADD_WEB_PROMOTION: "/api/admin/webpromotions/webpromotions/",
  ADD_BANNER: "/api/canco/banner/",
  ADD_BANNERS: "/api/canco/banners/",
  LOGIN_REFRESH: "/api/admin/accounts/login/refresh/",
  ADD_CAROUSEL: "/api/admin/canco/carousel/",
  ADD_PROPANE_POPUP: "/api/admin/propane/popups/",
  ADD_PROPANE_PROMOTION: "/api/admin/propane/promotions/",
};

export const DELETE_API_URLS = {
  DELETE_PROMO: "/api/admin/promotions/",
  DELETE_LOCATION: "/api/admin/canco/delete_store/",
  DELETE_PROPANE_POPUP: "/api/admin/propane/popups/",
  DELETE_PROPANE_PROMOTION: "/api/admin/propane/promotions/",
};

export const TIMINGS = [
  {
    day: "",
    open_time: "",
    close_time: "",
  },
  {
    day: "",
    open_time: "",
    close_time: "",
  },
  {
    day: "",
    open_time: "",
    close_time: "",
  },
  {
    day: "",
    open_time: "",
    close_time: "",
  },
  {
    day: "",
    open_time: "",
    close_time: "",
  },
  {
    day: "",
    open_time: "",
    close_time: "",
  },
  {
    day: "",
    open_time: "",
    close_time: "",
  },
];

export const COFFEE_PROMOTIONS = [
  {
    id: 1,
    title: "Configuration",
    icon: <Gear size={45} color="var(--secondaryColor)" />,
    link: "configurations",
  },
  {
    id: 2,
    title: "Site Rewards",
    icon: <Award size={45} color="var(--secondaryColor)" />,
    link: "site-rewards",
  },
  {
    id: 3,
    title: "User Rewards",
    icon: <Award size={45} color="var(--secondaryColor)" />,
    link: "user-rewards",
  },
];
